const LogoIcon = () => {
  return <img className="h-10 w-auto" src={'/images/logo.png'} alt="SureFire" />
}

export default LogoIcon
